import { render, staticRenderFns } from "./category_add.vue?vue&type=template&id=4e0a3253&"
import script from "./category_add.vue?vue&type=script&lang=ts&"
export * from "./category_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports